__turbopack_context__.v({
  "ariaSlider": "PlasmicSlider-module__4VtWjW__ariaSlider",
  "ariaSliderOutput": "PlasmicSlider-module__4VtWjW__ariaSliderOutput",
  "ariaSliderTrack": "PlasmicSlider-module__4VtWjW__ariaSliderTrack",
  "background": "PlasmicSlider-module__4VtWjW__background",
  "description": "PlasmicSlider-module__4VtWjW__description",
  "foreground": "PlasmicSlider-module__4VtWjW__foreground",
  "freeBox___9Cq1O": "PlasmicSlider-module__4VtWjW__freeBox___9Cq1O",
  "freeBox__aUzX3": "PlasmicSlider-module__4VtWjW__freeBox__aUzX3",
  "sliderThumb__tKzh8": "PlasmicSlider-module__4VtWjW__sliderThumb__tKzh8",
  "slotTargetLabel": "PlasmicSlider-module__4VtWjW__slotTargetLabel",
  "text": "PlasmicSlider-module__4VtWjW__text",
  "text__a6LiB": "PlasmicSlider-module__4VtWjW__text__a6LiB",
});
